import { doRequest } from '@r1-frontend/do-request/index';
import { makePaymentWithBinding } from '@r1-frontend/api-domru/api-pay/v1/payment/card';

import { EResultPopupStatus } from '@r1-frontend/ui-react/components/popups/popupResult';
import { RubleSymbol } from '@r1-frontend/ui-react/experimental/purchase/cost/Cost/RubleSymbol';
import { pluralize } from '@r1-frontend/shared/helpers/pluralize';
import { monthPluralize } from '@r1-frontend/shared/helpers/pluralize/predifined';

import { getTicketDataLayerLabel, pushDataLayer } from '~/src/features/payments-abn/components/SeasonTicketPayment/helpers';
import { setInProcess, setTicketPopup } from '~/src/features/payments-abn/components/SeasonTicketPayment/store/actionCreators';
import { ddmm } from '~/src/helpers/date';
import { toCurrency } from '~/src/helpers/numbers';
import { TAppThunkDispatch, TGetState } from '~/src/store';

const payByBindedCard = (amount: number) => {
    return async(dispatch: TAppThunkDispatch, getState: TGetState): Promise<void> => {
        dispatch(setInProcess(true));

        const {
            city: { provider: { providerId } },
            payment: { method },
            seasonTicketPayment: { seasonTicket },
        } = getState();

        const cardId = method?.id;

        const { activateDate = '', countMonth = 3, deltaPeriod = 0, sumPrice = 0, paySum = 0 } = seasonTicket || {};

        const params = {
            email: '',
            autopay_act: 0,
            payment_value: amount,
            binding_id: cardId,
            payment_source: 1,
            return_url: location.origin + '/payments-response?',
        };
        if (cardId) {
            const resp = await doRequest.apiPay(
                makePaymentWithBinding(providerId, params),
            );
            const { isSuccess } =  resp;

            pushDataLayer(
                isSuccess ? 'subscription_and_payment_success' : 'subscription_connect_success',
                getTicketDataLayerLabel({ countMonth, sumPrice, deltaPeriod }),
            );

            const title = isSuccess
                ? `Вы пополнили баланс на ${toCurrency(paySum)} ${RubleSymbol} и подключили абонемент на ${countMonth} ${pluralize(countMonth, monthPluralize)}`
                : 'Вы подключили абонемент, но пополнить баланс не получилось';
            const text = isSuccess ? `Абонемент начнёт действовать ${ddmm(activateDate)}` : '';

            dispatch(setTicketPopup({
                isOpen: true,
                step: isSuccess ? 'paid' : 'declined',
                title,
                text,
                type: isSuccess ? EResultPopupStatus.SUCCESS : EResultPopupStatus.WARNING,
            }));
        }


        dispatch(setInProcess(false));
    };
};

export default payByBindedCard;
